const fetchConfig = {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Accept: `application/json` }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cart = null
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initLoading()
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe('ON_ITEM_ADDED', async (parsedState) => {
      if (window.FoxThemeSettings.template === 'cart') {
        this.renderContents(parsedState)
      }
      const cart = await FoxThemeCartHelpers.getState()
      if (cart) {
        this.cart = cart
        FoxThemeCartHelpers.updateCartCount(cart.item_count)
      }
    });

    window.FoxThemeEvents.subscribe('ON_CART_UPDATED', (cart) => {
      this.cart = cart
      FoxThemeCartHelpers.updateCartCount(cart.item_count)
      this.classList.toggle('is-empty', cart.item_count === 0);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.body, { overlay: this.querySelector('.f-cart__items')})
  }

  onChange(event) {
    if (event.target.getAttribute('name') !== 'updates[]') return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${FoxThemeSettings.routes.cart_change_url}`, { ...fetchConfig, ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const updatedLine = this.querySelector(`#CartItem-${line}, #CartDrawer-Item-${line}`)

      const quantityElement = updatedLine.querySelector('[name="updates[]"]');
      const items = document.querySelectorAll('.f-cart-item');

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer');

      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');

      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);

      this.renderContents(parsedState)
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.FoxThemeStrings.cartError;
        } else {
          message = window.FoxThemeStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }

      this.updateLiveRegions(line, message);

      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawer
          ? trapFocus(cartDrawer, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawer) {
        //TODO: Check later
        // trapFocus(cartDrawer.querySelector('.drawer__inner-empty'), cartDrawer.querySelector('a'));
      } else if (document.querySelector('.f-cart-item') && cartDrawer) {
        trapFocus(cartDrawer, document.querySelector('.f-cart-item__name'));
      }
      window.FoxThemeEvents.emit(`ON_CART_UPDATED`, parsedState)
    })
    .catch(() => {
      const errors = document.querySelector('#cart-errors, #CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = window.FoxThemeStrings.cartError;
      }
    })
    .finally(() => {
      this.loading.finish()
    });
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });
  }

  updateLiveRegions(line, message) {
    if (!message) return;
    const lineItemError = this.querySelector(`#CartItem-${line}, #CartDrawer-Item-${line}`);

    window.FoxTheme.Notification.show({
      target: lineItemError.querySelector('.f-cart-item__quantity, .f-cart-drawer__error'),
      method: 'appendChild',
      type: 'warning',
      message: message,
      last: 5000
    })

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const domParser = new DOMParser().parseFromString(html, 'text/html')
    //console.log(domParser, selector, 'domParser')
    return domParser.querySelector(selector) ? domParser.querySelector(selector).innerHTML : '';
  }

  enableLoading() {
    this.loading.start()
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
}

customElements.define('cart-items', CartItems);

/* CUSTOM CART */

if (document.querySelector('.template-cart')) {

  document.querySelector('body').addEventListener('click', event => {
    if (event.target.matches('#checkout_sticky') || event.target.matches('#checkout') || event.target.closest('#checkout_sticky') || event.target.closest('#checkout')) {
      var agree = document.querySelector("#checkBoxTerminiCondizioni");
      var agree_error = document.querySelector("#checkout-is-required-input");
      if (!agree.checked) {
        event.preventDefault();
        agree_error.removeAttribute("hidden");
        agree_error.focus();
      } else {
        // Verifica se il campo Fidelity card è required e non vuoto

        /*
        var fidelityCardInput = document.querySelector('input[name="attributes[Fidelity card]"]');
        if (fidelityCardInput.required && !fidelityCardInput.value) {
          event.preventDefault();
          var fidelity_error = document.querySelector("#fidelity-is-required-input");
          fidelity_error.removeAttribute("hidden");
          fidelityCardInput.focus();
        }
        */



        const inputNames = [
          'attributes[Fidelity card]',
          'attributes[Ragione sociale]',
          'attributes[Indirizzo]',
          'attributes[CAP]',
          'attributes[Città]',
          'attributes[Provincia]',
          'attributes[Partita IVA]'
        ];

        inputNames.forEach(function(name) {
            var input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
            if (input && input.required && (!input.value || input.value == '')) {
                event.preventDefault();
                var errorElementId = input.getAttribute("data-error-id");
                var errorElement = document.querySelector("#" + errorElementId);
                if (errorElement) {
                    errorElement.removeAttribute("hidden");
                }
                input.focus();
            }
            else if (input && input.required && input.value) {
                var errorElementId = input.getAttribute("data-error-id");
                var errorElement = document.querySelector("#" + errorElementId);
                if (errorElement) {
                    errorElement.setAttribute("hidden",true);
                }
            }
        });

        var partitaIvaCheckbox = document.querySelector('.custom-radio-partita-iva:checked').value;
        var codiceSDIInput = document.querySelector('input[name="attributes[Codice SDI]"]');
        var indirizzoPECInput = document.querySelector('input[name="attributes[Indirizzo PEC]"]');
        if (partitaIvaCheckbox === 'Si' && !codiceSDIInput.value && !indirizzoPECInput.value) {
          event.preventDefault();
          var codiceSDI_error = document.querySelector("#codiceSDI_error-is-required-input");
          codiceSDI_error.removeAttribute("hidden");
          codiceSDIInput.focus();
        }




        
      }
    }
  });
  
  
  
  
  // Trigger the change event initially
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });
  
  
  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('custom-cart-pacchetto-regalo-radio')) {
      var thisRow = e.target.closest('tr');
      var fraseElement = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-frase-pacchetto-regalo');
      var thisFrase = fraseElement ? fraseElement.value : '';

      var Misura = e.target.closest('.custom-cart-pacchetto-regalo').querySelector('.misura-value').value;
      
      if(Misura != ''){
        var proprietsToChange = {
            'Pacchetto regalo': e.target.value,
            'Frase biglietto auguri': thisFrase,
            'Misura': Misura
          }
      }else{
        var proprietsToChange = {
            'Pacchetto regalo': e.target.value,
            'Frase biglietto auguri': thisFrase
          }
      }
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: e.target.getAttribute('data-line'),
          properties: proprietsToChange
        })
      });
  
      thisRow.querySelectorAll('.custom-cart-pacchetto-regalo-radio.active').forEach(function(el) {
        el.classList.remove('active');
      });
      e.target.classList.add('active');
  
      thisRow.querySelectorAll('.custom-frase-pacchetto-regalo-wrap').forEach(function(el) {
        el.style.display = 'none';
      });
      var fraseWrapElement = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-frase-pacchetto-regalo-wrap');
      if (fraseWrapElement) {
        fraseWrapElement.style.display = 'block';
      }
    }
  });
  
  
  document.addEventListener('blur', function(e) {
    if (e.target && e.target.classList.contains('custom-frase-pacchetto-regalo')) {
      var thisPacchetto = e.target.closest('.cart-regalo-option-wrap').querySelector('.custom-cart-pacchetto-regalo-radio').value;
      var thisFrase = e.target.value;
  
      var Misura = e.target.closest('.custom-cart-pacchetto-regalo').querySelector('.misura-value').value;
      
      //console.log('Misura: ' + Misura);

      if(Misura != ''){
        var proprietsToChange = {
            'Pacchetto regalo': thisPacchetto,
            'Frase biglietto auguri': thisFrase,
            'Misura': Misura
          }
      }else{
        var proprietsToChange = {
            'Pacchetto regalo': thisPacchetto,
            'Frase biglietto auguri': thisFrase
          }
      }
  
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: e.target.getAttribute('data-line'),
          properties: proprietsToChange
        })
      });
    }
  }, true);
  
  
  document.addEventListener('keydown', updateFrasePacchetto);
  document.addEventListener('keyup', updateFrasePacchetto);
  
  function updateFrasePacchetto(e) {
    if (e.target && e.target.classList.contains('custom-frase-pacchetto-regalo')) {
      var thisValue = e.target.value;
      e.target.closest('.cart-regalo-option-wrap').siblings('.cart-regalo-option-wrap').forEach(function(sibling) {
        sibling.querySelectorAll('.custom-frase-pacchetto-regalo').forEach(function(input) {
          input.value = thisValue;
        });
      });
    }
  }
  
  Element.prototype.siblings = function(selector) {
    return Array.from(this.parentNode.children).filter(function(child) {
      return child !== this && (!selector || child.matches(selector));
    }, this);
  };
  
  
  
  
  
  
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    element.addEventListener('change', function() {
      var checkedValue = document.querySelector('.custom-radio-fidelity:checked').value;
  
      if (checkedValue === 'Si') {
        document.querySelectorAll('.cart-custom-field-fidelity').forEach(function(field) {
          field.style.display = 'block';
        });
        document.querySelectorAll('.cart-custom-field-fidelity.cart-custom-field-fidelity-required input,.cart-custom-field-fidelity.cart-custom-field-fidelity-required select').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
      } else {
        document.querySelectorAll('.cart-custom-field-fidelity').forEach(function(field) {
          field.style.display = 'none';
        });
        document.querySelectorAll('.cart-custom-field-fidelity input,.cart-custom-field-fidelity select').forEach(function(input) {
          input.value = '';
        });
        document.querySelectorAll('.cart-custom-field-fidelity.cart-custom-field-fidelity-required input,.cart-custom-field-fidelity.cart-custom-field-fidelity-required select').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
  
        var fidelity_error = document.querySelector("#fidelity-is-required-input");
        fidelity_error.setAttribute("hidden", true);
  
        // Svuota il valore dell'input prima di inviare la richiesta
        var formData = new FormData();
        formData.append("attributes[Fidelity card?]", checkedValue);
        formData.append("attributes[Fidelity card]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
  
        // Uscire dalla funzione per evitare la doppia richiesta
        return;
      }
  
      // Invio del valore dell'input radio al server
      var formData = new FormData();
      formData.append("attributes[Fidelity card?]", checkedValue);
  
      // Se il valore selezionato è 'Si', aggiungi anche il valore dell'input aggiuntivo
      if (checkedValue === 'Si') {
        var fidelityInputValue = document.querySelector('input[name="attributes[Fidelity card]"]').value;
        formData.append("attributes[Fidelity card]", fidelityInputValue);
      }
  
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    });
  });
  
  // Aggiungi listener per l'evento blur sull'input name="attributes[Fidelity card]"
  /*
  document.querySelector('input[name="attributes[Fidelity card]"]').addEventListener('blur', function() {
    var fidelityInputValue = this.value;
    var formData = new FormData();
    formData.append("attributes[Fidelity card]", fidelityInputValue);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.error('Error:', error));
  });
  */


  // Definisci i nomi degli input da controllare
  const inputNames = [
    'attributes[Fidelity card]',
    'attributes[Ragione sociale]',
    'attributes[Indirizzo]',
    'attributes[CAP]',
    'attributes[Città]',
    'attributes[Provincia]',
    'attributes[Partita IVA]',
    'attributes[Codice SDI]',
    'attributes[Indirizzo PEC]'
  ];
  
  inputNames.forEach(name => {
    const input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
    if (input) {
      input.addEventListener('blur', function() {
        var formData = new FormData();
  
        inputNames.forEach(name => {
          const input = document.querySelector(`input[name="${name}"],select[name="${name}"]`);
          if (input) {
            formData.append(name, input.value);
          }
        });
  
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
      });
    }
  });



  
  
  // Trigger del cambiamento iniziale
  document.querySelectorAll('.custom-radio-fidelity').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });




  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    element.addEventListener('change', function() {
      var checkedValue = document.querySelector('.custom-radio-partita-iva:checked').value;
  
      if (checkedValue === 'Si') {
        document.querySelectorAll('.cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'block';
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = true;
          input.classList.add('required');
        });
      } else {
        document.querySelectorAll('cart-custom-field-billing-group,.cart-custom-field-billing').forEach(function(field) {
          field.style.display = 'none';
        });
        document.querySelectorAll('.cart-custom-field-billing input').forEach(function(input) {
          input.value = '';
        });
        document.querySelectorAll('.cart-custom-field-billing select').forEach(function(input) {
          input.selectedIndex = 0; 
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required input').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
        document.querySelectorAll('.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function(input) {
          input.required = false;
          input.classList.remove('required');
        });
  
        //var fidelity_error = document.querySelector("#fidelity-is-required-input");
        //fidelity_error.setAttribute("hidden", true);

        document.querySelectorAll('.cart-custom-field-billing-group .invalid-feedback span').forEach(function(iva_error) {
          iva_error.setAttribute("hidden", true);
        });

        
  
        // Svuota il valore dell'input prima di inviare la richiesta
        var formData = new FormData();
        formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
        formData.append("attributes[Ragione sociale]", "");
        formData.append("attributes[Indirizzo]", "");
        formData.append("attributes[CAP]", "");
        formData.append("attributes[Città]", "");
        formData.append("attributes[Provincia]", "");
        formData.append("attributes[Partita IVA]", "");
        formData.append("attributes[Codice SDI]", "");
        formData.append("attributes[Indirizzo PEC]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error));
  
        // Uscire dalla funzione per evitare la doppia richiesta
        return;
      }
  
      // Invio del valore dell'input radio al server
      var formData = new FormData();
      formData.append("attributes[Vuoi ricevere la fattura?]", checkedValue);
  
      // Se il valore selezionato è 'Si', aggiungi anche il valore dell'input aggiuntivo
      if (checkedValue === 'Si') {
        var ragioneSocialeValue = document.querySelector('input[name="attributes[Ragione sociale]"]').value;
        formData.append("attributes[Ragione sociale]", ragioneSocialeValue);

        var indirizzoValue = document.querySelector('input[name="attributes[Indirizzo]"]').value;
        formData.append("attributes[Indirizzo]", indirizzoValue);

        var capValue = document.querySelector('input[name="attributes[CAP]"]').value;
        formData.append("attributes[CAP]", capValue);

        var cittaValue = document.querySelector('input[name="attributes[Città]"]').value;
        formData.append("attributes[Città]", cittaValue);

        var provinciaValue = document.querySelector('select[name="attributes[Provincia]"]').value;
        formData.append("attributes[Provincia]", provinciaValue);

        var partitaIVAValue = document.querySelector('input[name="attributes[Partita IVA]"]').value;
        formData.append("attributes[Partita IVA]", partitaIVAValue);

        var codiceSDIValue = document.querySelector('input[name="attributes[Codice SDI]"]').value;
        formData.append("attributes[Codice SDI]", codiceSDIValue);

        var indirizzoPECValue = document.querySelector('input[name="attributes[Indirizzo PEC]"]').value;
        formData.append("attributes[Indirizzo PEC]", indirizzoPECValue);
      }
  
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    });
  });

  // Trigger del cambiamento iniziale
  document.querySelectorAll('.custom-radio-partita-iva').forEach(function(element) {
    var event = new Event('change');
    element.dispatchEvent(event);
  });




  

  


}